module.exports = __webpack_public_path__ + "img/p8-p1-chuan1.e73c7cb3.png";